var $ = require('jquery')
var TimesheetList = require('../models/timesheetmodel')
var Global = require('../services/globalservice')
var authService = require('../services/authenticationservice')
// var axios = require('axios')

var TIMESHEET_URL = Global.HOST + 'api/timesheet/getTimesheet'
var SAVE_TIMESHEET_URL = Global.HOST + 'api/timesheet/saveTimesheetOfUser'
var SHINSEI_OT_URL = Global.HOST + 'api/timesheet/shinseiOT'
var GET_TOKEN_EXPORT_EXCEL_URL = Global.HOST + 'api/timesheet/getExcelExportToken'
var GET_SHINSET_HISTORY_TIME_URL = Global.HOST + 'api/shinseiOT/getShinseiHistoryTime'
var CREATE_TIMESHEET_ZIP_FILE = Global.HOST + 'api/timesheet/createTimesheetZipFile'
var GET_PREVIEW_TIMESHEET = Global.HOST + 'api/timesheet/getPreviewTimeSheet'
var GET_TIMESHEET_STATUS_OF_USER = Global.HOST + 'api/timesheet/getTimesheetStatusOfUser'
var SUBMIT_TIMESHEET = Global.HOST + 'api/timesheet/submitPreviewTimesheet'
var APPROVE_TIMESHEET = Global.HOST + 'api/timesheet/approvePreviewTimesheet'
var REJECT_TIMESHEET = Global.HOST + 'api/timesheet/rejectPreviewTimesheet'
var ACCEPT_OT_REQUEST = Global.HOST + 'api/tokenMail/acceptOT'
var REJECT_OT_REQUEST = Global.HOST + 'api/tokenMail/rejectOT'
var APPROVE_ALL_OT_REQUEST = Global.HOST + 'api/tokenMail/acceptAllOTShinsei'
var REJECT_ALL_OT_REQUEST = Global.HOST + 'api/tokenMail/rejectAllOTShinsei'
let GET_TOKEN_MAIL_BY_SHINSEI_ID = Global.HOST + 'api/tokenMail/getTokenByShinseiId'

module.exports = {
    // get List Timesheet data of a user
    getListOf: function (condition, callback, error) {
      return $.ajax({
        method: 'GET',
        url: TIMESHEET_URL,
        data: condition,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          var timesheet = new TimesheetList(response.data)

          callback(timesheet)
        },
        error: function (err) {
          console.log(err)
        }
      })
    },
    // save timesheet of a user
    saveList: function (data, userID, callback, error) {
      $.ajax({
        method: 'POST',
        url: SAVE_TIMESHEET_URL,
        data: {
          data: JSON.stringify(data),
          user_id: userID
        },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response)
        },
        error: function (err) {
          error(err)
        }
      })
    },
    // send shinseiOT requet
    shinseiOT: function (data, callback, error) {
      $.ajax({
        method: 'POST',
        url: SHINSEI_OT_URL,
        data: { 'data': JSON.stringify(data) },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response)
        },
        error: function (err) {
          error(err)
        }
      })
    },

    // get token to export excel
    getTokenExportExcel: function (callback, error) {
      $.ajax({
        method: 'GET',
        url: GET_TOKEN_EXPORT_EXCEL_URL,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response)
        },
        error: function (err) {
          error(err)
        }
      })
    },
    // get shinsei OT history time of user
    getShinseiHistoryTime: function (workingDate, callback, error) {
      $.ajax({
        method: 'GET',
        data: {
          'working_date': workingDate
        },
        url: GET_SHINSET_HISTORY_TIME_URL,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response)
        },
        error: function (err) {
          error(err)
        }
      })
    },
    // send request to create timesheet .zip file on server, and request forlder name
    createTimesheetZipFile: function (month, year, callback, error) {
      $.ajax({
        method: 'POST',
        data: {
          'month': month,
          'year': year
        },
        url: CREATE_TIMESHEET_ZIP_FILE,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    getPreviewTimesheet: function (userId, month, year, callback, error) {
      $.ajax({
        method: 'GET',
        data: {
          'user_id': userId,
          'month': month,
          'year': year
        },
        url: GET_PREVIEW_TIMESHEET,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          callback(response)
        },
        error: function (err) {
          error(err)
        }
      })
    },

    getTimesheetStatusOfUser: function (timesheet, callback, error) {
      $.ajax({
        method: 'POST',
        data: {data: JSON.stringify(timesheet)},
        url: GET_TIMESHEET_STATUS_OF_USER,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    submitTimesheet: function (timesheet, callback, error) {
      $.ajax({
        method: 'POST',
        data: {data: JSON.stringify(timesheet)},
        url: SUBMIT_TIMESHEET,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    approveTimesheet: function (timesheet, callback, error) {
      $.ajax({
        method: 'POST',
        data: {data: JSON.stringify(timesheet)},
        url: APPROVE_TIMESHEET,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    rejectTimesheet: function (timesheet, callback, error) {
      $.ajax({
        method: 'POST',
        data: {data: JSON.stringify(timesheet)},
        url: REJECT_TIMESHEET,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    getTokenMailByShinseiId: function (dayoffId, callback, error) {
      $.ajax({
        method: 'POST',
        url: GET_TOKEN_MAIL_BY_SHINSEI_ID,
        data: { id: dayoffId },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    approveRejectOTRequest: function (action, token, callback, error) {
      let url = action === 'approve' ? ACCEPT_OT_REQUEST : REJECT_OT_REQUEST
      $.ajax({
        method: 'GET',
        url: url + '/' + token + '/0',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    approveAllOtShinseiRequest: function (data, callback, error) {
      let url = APPROVE_ALL_OT_REQUEST
      $.ajax({
        method: 'POST',
        data, 
        url,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },

    rejectAllOtShinseiRequest: function (data, callback, error) {
      let url = REJECT_ALL_OT_REQUEST
      $.ajax({
        method: 'POST',
        data, 
        url,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', authService.default.getAuthHeader())
        },
        success: function (response) {
          if (response.status === 'success') {
            callback(response.data)
          } else {
            error(response)
          }
        },
        error: function (err) {
          error(err)
        }
      })
    },
}



// WEBPACK FOOTER //
// ./client/services/timesheetservice.js